var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UmbracoImage',_vm._b({staticClass:"c-umbraco-image-ext"},'UmbracoImage',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }